import { render, staticRenderFns } from "./projectIndex.vue?vue&type=template&id=4f8359e0&scoped=true&"
import script from "./projectIndex.vue?vue&type=script&lang=js&"
export * from "./projectIndex.vue?vue&type=script&lang=js&"
import style0 from "./projectIndex.vue?vue&type=style&index=0&id=4f8359e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8359e0",
  null
  
)

export default component.exports